<div *ngIf="extraUpsell" class="upsell-popup-holder">
  <ng-container *ngTemplateOutlet="upsellPopover"></ng-container>
</div>
<div #card class="ing-card primary-bg-color margin-5 font-primary"
     [ngClass]="{'active': isOrdered, 'with-tags': hasTags}">
  <ng-container *ngIf='imgSrc'>
    <img class="ing-img" ftsPicture #pictureRef='pictureRef' [imgSrc]='imgSrc' (pictureSet)="onPictureSet()" [attr.alt]="!imgSrc ? '' : ingredient?.name" aria-hidden="true">
    <fts-ghost-element class="ing-img" *ngIf='imgSrc && !pictureRef?.isLoaded' [height]="(viewportService?.viewport$ | async)?.isMobile ? 170 : 200" [width]="(viewportService?.viewport$ | async)?.isMobile ? 170 : 200"></fts-ghost-element>
  </ng-container>
  <div *ngIf="isDisabled" class="card-disabled secondary-bg-color disabled" [ngStyle]="{'height': (!isDisabledQualifier && ingredient.qualifiers.length>0) ? 'calc(100% - ' + disableWrapperHeight + ')' : 'inherit'}" [tabindex]="0" (click)="onIngredientClick()">
    <div class="sr-only">{{ingredient.name + ((choice.defaultsNonRemovable ? 'component.item_editor.choice.ingredient.ingredient_card.non_removable' : 'component.item_editor.choice.ingredient.ingredient_card.not_available') | translate)}}</div>
    <div class="sold-out-container" *ngIf="!(this.choice.defaultsNonRemovable && this.ingredient.isDefault) ">
      <div [ngClass]="{'size-specific': storeConfig?.showSizeSpecificIngredients}" class="sold-out secondary-text-color text-uppercase">{{(!storeConfig?.showSizeSpecificIngredients ? 'component.item_editor.choice.ingredient.ingredient_card.not_available' : 'component.item_editor.choice.ingredient_info.not_available_size') | translate : { sizes: availableSizes} }}</div>
    </div>
    <div>

    </div>
  </div>
  <div class="card-cont noselect"
       [style.backgroundColor]="!isOrdered && ingredient.isDefault ? ((theme$ | async)?.selectionColor | rgba: '0.5') : 'initial'"
       >
    <button class="btn-nostyle btn-overlay"
            [style.zIndex]="isOrdered ? '-1' : '1'"
            [attr.aria-label]="ingredient.name + ((isOrdered ? 'component.item_editor.choice.ingredient.ingredient_card.checked' : 'component.item_editor.choice.ingredient.ingredient_card.not_checked') | translate)"
            (click)="toggleIngredient()"></button>
    <div *ngIf="choice.showIngredientPrices || !!ingredient.description"
         class="price-description-row over-selection"
         [ngClass]="{'description-only' : !choice.showIngredientPrices}">
      <div *ngIf="choice.showIngredientPrices"
           class='padded-left-10 padded-right-10 padded-bottom-5 padded-top-5 ingredient-price'
           [attr.aria-label]="('component.item_editor.choice.ingredient.ingredient_card.ingredient_price' | translate) + ingredientPrice"
           [style.backgroundColor]="isOrdered ? 'initial' : (theme$ | async)?.primaryBackgroundColor | rgba: '0.7'"
           [ngClass]="isOrdered ? 'selection-bg-color selection-inverse-text-color' : 'primary-text-color'">
        {{ingredientPrice | currency:'USD':'symbol'}}
      </div>
      <button *ngIf="!!ingredient.description"
           [ngbPopover]="description"
           [placement]="'left'"
           class='btn-nostyle padded-left-10 padded-right-10 padded-bottom-5 padded-top-5 ingredient-description'
           [ngClass]="{'selection-bg-color': isOrdered}"
           [style.backgroundColor]="isOrdered ? 'initial' : (theme$ | async)?.primaryBackgroundColor | rgba: '0.7'"
           (click)="ingredientDescriptionClicked($event)">
        <fa-icon [icon]="faQuestionCircle" [ngClass]="isOrdered ? 'selection-inverse-text-color' : 'primary-text-color'"></fa-icon>
        <span class="sr-only primary-bg-color primary-text-color">{{'component.item_editor.choice.ingredient.ingredient_card.ingredient_description' | translate}}</span>
      </button>
    </div>
    <div [@scaleX]="isOrdered" class="top-info noselect" [style.backgroundColor]="isOrdered ? ((theme$ | async)?.selectionColor | rgba : '0.5') : 'initial'">
      <ng-container *ngIf="!isOrdered && ingredient.isDefault">
        <div class="half-selection noselect center">
          <div class="my-center primary-bg-color">
              <div class="checkmark-container selection-text-color times-alignment" aria-hidden="true">
                &times;
              </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isOrdered">
        <button *ngIf="ingredient.allowHalves" class="half-selection noselect btn-nostyle padding-0"
             (click)='selectHalf(true, false)'
             [disabled]="isDisabled"
             [attr.aria-label]="('component.item_editor.choice.ingredient.ingredient_card.left_half' | translate) + (orderedIngredient?.isLeftHalf ? ('component.item_editor.choice.ingredient.ingredient_card.checked' | translate) : '')">
          <div *ngIf="ingredient.allowHalves"
               class="my-left"
               [style.backgroundColor]="orderedIngredient && !orderedIngredient.isLeftHalf ? ((theme$ | async)?.primaryBackgroundColor | rgba : '0.6') : 'initial'"
               [ngClass]="{'primary-bg-color': orderedIngredient?.isLeftHalf}"
              >
              <div class="checkmark-container padding-top">
                <div *ngIf="orderedIngredient?.isLeftHalf" class="checkmark is-half selection-text-color noselect" aria-hidden="true">L</div>
              </div>
            </div>
          <div [ngClass]="{'half-text-visible' : orderedIngredient?.isLeftHalf}" class="half-text selection-text-color noselect primary-bg-color text-uppercase">
            {{'component.item_editor.choice.ingredient.ingredient_card.left_side' | translate}}
          </div>
        </button>
        <button class="half-selection noselect center btn-nostyle padding-0"
             (click)='selectHalf(false, false)'
             [disabled]="isDisabled"
             [attr.aria-label]="('component.item_editor.choice.ingredient.ingredient_card.whole' | translate)
              + (orderedIngredient && !orderedIngredient.isLeftHalf && !orderedIngredient.isRightHalf ?
               ('component.item_editor.choice.ingredient.ingredient_card.checked' | translate): '')">
          <div class="my-center"
               [style.backgroundColor]="orderedIngredient && (orderedIngredient.isLeftHalf || orderedIngredient.isRightHalf) ? ((theme$ | async)?.primaryBackgroundColor | rgba : '0.6') : 'initial'"
               [ngClass]="{'primary-bg-color': orderedIngredient && !orderedIngredient.isLeftHalf && !orderedIngredient.isRightHalf}">
                <div class="checkmark-container">
                  <div *ngIf="!orderedIngredient?.isLeftHalf && !orderedIngredient?.isRightHalf" class="checkmark selection-text-color noselect" aria-hidden="true">L</div>
                </div>
          </div>
          <ng-container *ngIf="ingredient.allowHalves">
            <div [ngClass]="{'half-text-visible' : !orderedIngredient?.isLeftHalf && !orderedIngredient?.isRightHalf}" class="half-text selection-text-color noselect primary-bg-color text-uppercase">
              {{'component.item_editor.choice.ingredient.ingredient_card.all' | translate}}
            </div>

          </ng-container>
        </button>
        <button *ngIf="ingredient.allowHalves" class="half-selection noselect btn-nostyle padding-0"
             (click)='selectHalf(false, true)'
             [disabled]="isDisabled"
             [attr.aria-label]="('component.item_editor.choice.ingredient.ingredient_card.right_half' | translate) + (orderedIngredient?.isRightHalf ?
              ('component.item_editor.choice.ingredient.ingredient_card.checked' | translate): '')">
          <div *ngIf="ingredient.allowHalves"
               class="my-right"
               [style.backgroundColor]="orderedIngredient && !orderedIngredient.isRightHalf ? ((theme$ | async)?.primaryBackgroundColor | rgba : '0.6') : 'initial'"
               [ngClass]="{'primary-bg-color': orderedIngredient?.isRightHalf}">
                <div class="checkmark-container padding-top">
                  <div *ngIf="orderedIngredient?.isRightHalf" class="checkmark is-half selection-text-color noselect" aria-hidden="true">L</div>
                </div>
          </div>
          <div [ngClass]="{'half-text-visible' : orderedIngredient?.isRightHalf}" class="half-text selection-text-color noselect primary-bg-color text-uppercase">
            {{'component.item_editor.choice.ingredient.ingredient_card.right_side' | translate}}
          </div>
        </button>
      </ng-container>
    </div>

    <div class="bottom-info" [ngClass]="{'selection-bg-color bottom-info-selected' : isOrdered}">

      <div *ngIf="!isOrdered" class="ing-info" ></div>

      <div class="ing-info" [ngClass]="{'primary-bg-color' : !isOrdered}">
        <div class="ing-name noselect" [ngClass]="{'selection-inverse-text-color' : isOrdered}">{{ingredient.name}}</div>
        <ng-container *ngIf="storeConfig?.showCalories && !isUnavailable">
          <div class="ing-cal noselect" [ngClass]="{'selection-inverse-text-color' : isOrdered}" *ngIf="calories">{{calories}} cal.<span *ngIf='servingLabel'> per {{servingLabel}}</span></div>
        </ng-container>
      </div>
      <div *ngIf="isOrdered && hasTags" class="d-flex align-items-center ingredient-tag-wrapper">
        <ng-container [ngTemplateOutlet]="ingredientTags"></ng-container>
      </div>
      <div #qualifierWrapper>
        <div [ngClass]="{'d-none': !(!shouldShowQualifiers && isOrdered && ingredient.qualifiers.length>0)}" class="qualifier-extra-btn">
          <button (click)="toggleShowQualifiers()"
               class="btn-nostyle q-button selection-inverse-text-color q-button-bordered noselect"
               [disabled]="isDisabledQualifier">
            {{(sideOnly ? 'component.item_editor.choice.ingredient.ingredient_card.side' : 'component.item_editor.choice.ingredient.ingredient_card.extra') | translate}}
          </button>
        </div>
        <div *ngIf="shouldShowQualifiers" [ngClass]="{'d-none': !isOrdered || !(isOrdered && shouldShowQualifiers) && !!qualifierGroups && (qualifierGroups?.length > 1 || qualifierGroups[0]?.length > 1)}" class="qualifier-info" [id]="'qualifierInfoGroup-' + ingredient?.name">
         <div class="sr-only">{{'component.item_editor.choice.ingredient.ingredient_card.extra_q_available' | translate}}</div>
          <ng-container *ngFor="let group of qualifierGroups;">
            <span class="thin-margin"></span>
            <ng-container *ngFor="let qualifier of group">
              <span class="thin-margin"></span>
              <button (click)="toggleQualifier(qualifier)"
                   class="btn-nostyle q-button noselect"
                   [ngClass]="(orderedIngredient | qualifierIsOrdered : qualifier) ? 'selection-inverse-bg-color selection-text-color' : 'selection-inverse-text-color'"
                   [disabled]="isDisabledQualifier"
                   [attr.aria-pressed]="orderedIngredient | qualifierIsOrdered : qualifier"
                   [attr.aria-label]="qualifier.name + ((orderedIngredient | qualifierIsOrdered : qualifier) ?
                   ('component.item_editor.choice.ingredient.ingredient_card.checked' | translate) :
                    ('component.item_editor.choice.ingredient.ingredient_card.not_checked' | translate))">
                {{qualifier.name | uppercase}}</button>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div class="ingredient-tag-wrapper" *ngIf="!orderedIngredient && hasTags">
        <ng-container [ngTemplateOutlet]="ingredientTags"></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #description>
  <div class='primary-bg-color primary-text-color text-center ingredient-card-popover-body' [ngClass]="{'popover-width': inItemEditorModal && !(breakpointSerivce.isTabletDown$ | async)}">
    <span>{{ingredient.description}}</span>
  </div>
</ng-template>

<ng-template #upsellPopover>
  <div #popoverRef class="upsell-info action-bg-color text-center" tabindex="-1" [ngClass]="{'in-modal': inItemEditorModal && !(breakpointSerivce.isTabletDown$ | async)}">
    <div class="text-container">
      <span class="action-inverse-text-color">
        <b><u>{{extraUpsell?.qualifier?.name}}</u></b> {{extraUpsell?.ingredient}}
        {{'component.item_editor.choice.ingredient.ingredient_card.for_only' | translate}}
        {{extraUpsell?.priceDiff | currency:'USD':'symbol'}}
        {{'component.item_editor.choice.ingredient.ingredient_card.more' | translate}}
      </span>
    </div>
    <div class="button-container">
      <button class="btn action-inverse-border-color ingredient-qualifier-btn font-secondary margin-5"
              (click)="toggleQualifier(extraUpsell?.qualifier, true)">
        <span class="action-inverse-text-color" translate>component.item_editor.choice.ingredient.ingredient_card.add_it</span>
      </button>
      <button class="btn btn-link btn-undecorated padding-0  margin-5" (click)="denyExtraUpsell()">
        <span class="secondary-text-color font-secondary" translate>component.item_editor.choice.ingredient.ingredient_card.no_thanks</span>
      </button>
    </div>
    <div class="popover-arrow" [ngClass]="{'in-modal': inItemEditorModal && !(breakpointSerivce.isTabletDown$ | async)}">
      <fa-icon *ngIf="!inItemEditorModal || (inItemEditorModal && (breakpointSerivce.isTabletDown$ | async))" [icon]="faCaretDown" size="2x" class="action-text-color"></fa-icon>
      <fa-icon *ngIf="inItemEditorModal && !(breakpointSerivce.isTabletDown$ | async)" [icon]="faCaretUp" size="2x" class="action-text-color"></fa-icon>
    </div>
  </div>
</ng-template>

<ng-template #ingredientTags>
  <fts-ingredient-tags
          [ingredient]="ingredient"
          [isInIngredientCard]="true"
          [isSelectedIngredientCard]="isOrdered"  
          (tagClicked)="tagClicked.emit($event)"></fts-ingredient-tags>
</ng-template>